import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { CategoryItem, Supplier, User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import useCategory from '../../api/hooks/useCategory';
import useToggle from '../../hooks/useToggle';
import { toIcons } from '../../consts/Paths';
import { useForm } from 'react-hook-form';
import DeleteModal from '../modals/DeleteModal';
import Loader from '../Loader';
import CustomModal from '../modals/CustomModal';
import CustomInput from '../inputs/CustomInput';
import useOffer from '../../api/hooks/useOffers';

const Suppliers = (props: any) => {
    const { isMobile } = useIsMobile();

    const { isToggled } = props.resetList;

    const { user, userTreated } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useOffer();

    const [suppliers, setSuppliers] = useState<Supplier[]>([]);

    const [edit, setEdit] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [item, setItem] = useState<Supplier>({
        id:0,
        cod:'s',
        phone:'s',
        address:'s',
        email:'s',
        description:'s'
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        setIsLoading(true);
        CTAs.updateSupplier(data,item.id);
    };

    const openEdit = (data: any) => {
        setItem(data);
        setEdit(true);
    };

    useEffect(() => {
        reset(); // Reset the form when the modal is closed
    }, [edit, item]);



    useEffect(() => {
        CTAs.getSuppliers();
    }, [isToggled, user, userTreated, RESPONSES.deleteSuppliersResponse,RESPONSES.updateSupplierResponse]);

    
    const handelOnDeleteClick = useCallback(
        (id: number) => {
            CTAs.deleteSupplier(id);
        },
        [CTAs.deleteSupplier]
    );

    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.updateSupplierResponse?.ok) {
            setIsLoading(false);
            setEdit(false);
        } else if (RESPONSES.updateSupplierResponse?.ok === false) {
            setIsLoading(false);
        }
    }, [RESPONSES.updateSupplierResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getSuppliersResponse?.ok) {
            setSuppliers(
                RESULTS.getSuppliersResult.map((item: any) => ({
                    id:item.id,
                    cod:item.cod,
                    phone:item.phone,
                    address:item.address,
                    email:item.email,
                    description:item.description
                }))
            );
        }
    }, [RESPONSES.getSuppliersResponse,RESPONSES.updateSupplierResponse]);

    const renderSuppliers = suppliers.map((supp) => {
        return (
            
            <div key={supp.id} style={{ margin: '10px 0px' }} className='user-card' onClick={()=>openEdit(supp)}>
                <p style={{ fontFamily: 'Roboto' ,marginRight:'20px'}}>{supp.cod}</p>
                <p style={{ fontFamily: 'Roboto' ,marginRight:'20px'}}>{supp.phone}</p>
                <p style={{ fontFamily: 'Roboto' ,marginRight:'20px'}}>{supp.email}</p>
                <p style={{ fontFamily: 'Roboto' ,marginRight:'20px'}}>{supp.address}</p>
                <p style={{ fontFamily: 'Roboto' ,marginRight:'20px'}}>{supp.description}</p>


                <button style={{ width: 50, marginLeft: 10, height: 20, paddingTop: 5, borderRadius: 14 }} className='add-button' onClick={() => openEdit(supp)}>
                                            <p style={{ fontSize: 12, margin: 0 }} className='add-buttonText'>
                                                Edit
                                            </p>
                                        </button>
                 <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(supp.id)}
                />
              
            </div>

        );
    });

    return (
          
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
              {edit && (
                <CustomModal setShow={setEdit} title='Modifica' description=''>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                        <CustomInput
                            title={'Cod'}
                            name={'cod'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.cod}
                            constraints={{
                                required: true,
                            }}
                        />
                        <CustomInput
                            title={'Description'}
                            name={'description'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.description}
                            constraints={{
                                required: true,
                            }}
                        />
                        <CustomInput
                            title={'Phone'}
                            name={'phone'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.phone}
                            constraints={{
                                required: true,
                            }}
                        />
                        <CustomInput
                            title={'Address'}
                            name={'address'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.address}
                            constraints={{
                                required: true,
                            }}
                        />
                        <CustomInput
                            title={'Email'}
                            name={'email'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.email}
                            constraints={{
                                required: true,
                            }}
                        />
                        <input type='text' value={item.id} hidden {...register('id')} />
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button style={{ width: 70, marginTop: 20 }} className='add-button' type='submit'>
                                <p className='add-buttonText'>Salva</p>
                            </button>
                        )}
                    </form>
                </CustomModal>
            )}
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Fornitori</p>
                    <p className='user-table-header-description'>Manage Fornitori</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add fornitore</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight:'40px',
                            }}
                        >
                            <p className='field-label'>Cod</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight:'40px',

                            }}
                        >
                            <p className='field-label'>Phone</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight:'40px',

                            }}
                        >
                            <p className='field-label'>Email</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight:'40px',

                            }}
                        >
                            <p className='field-label'>Address</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight:'40px',

                            }}
                        >
                            <p className='field-label'>Description</p>
                        </div>

                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'></p>
                            </div>
                        )}
                        <div
                            className='u-status'
                            style={{
                                marginLeft: isMobile ? '135px' : '',
                            }}
                        >
                            <p className='field-label'></p>
                        </div>
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    {suppliers.length > 0 ? <div className='users-table-results scroll-y'>{renderSuppliers}</div> : <Loader />}
                </div>
            </div>
        </div>
    );
};
export default Suppliers;
